/*
  Button.jsx
*/

// Npm.
import React, { useMemo } from 'react';

// Makes.
import { makeStyles, cx } from '../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    '&.btn': {
      letterSpacing: '0.05em',  // Buttons have less letter spacing for some reason.
    },
    fontWeight: 500,
    fontSize: '0.875rem',
    color: theme.color_text_primary,
    lineHeight: '1.2',
    textDecoration: 'none',
    margin: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    minWidth: 64,
    padding: theme.space(1, 2),
    backgroundColor: 'transparent',
    outline: 'none',
    borderRadius: 4,
    border: `1px solid ${theme.color_text_secondary}`,
    transition: 'background-color 0.1s ease',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.action_hover,
    },
    '&:focus-visible': {
      backgroundColor: theme.action_hover,
    },
    '&:disabled': {
      cursor: 'inherit',
      color: theme.color_text_disabled,
      borderColor: theme.color_divider,
      backgroundColor: 'transparent',
    },
    '&.fullWidth': {
      minWidth: 0,
      width: '100%',
    },
    '&.small': {
      fontSize: '0.8125rem',
      padding: theme.space(0.5, 1),
    },
  },
}));

/**
 * Renders a simple button. Similar to MUI button.
 */
export default function Button({ className, component = 'button', size, color, fullWidth, ...rest }) {

  let rootClass = 'Button';

  if (component === 'button') {
    rootClass += ' btn';
  }

  if (size === 'small') {
    rootClass += ' small';
  }

  if (fullWidth) {
    rootClass += ' fullWidth';
  }

  // TODO: Use color prop.

  const classes = useStyles();
  const cls = useMemo(() => cx(rootClass, classes.root, className), [rootClass, classes.root, className]);

  const Component = component;

  return (
    <Component
      type="button"
      className={cls}
      {...rest}
    />
  );
}
